export function Field({ id, label, error, hint, optional, children }) {
  return (
    <div>
      <label htmlFor={id} className="flabel">
        {label} {optional ? <span className="font-normal text-mute">(facultatif)</span> : <span aria-hidden="true" className="text-accent">*</span>}
      </label>
      {children}
      {hint && !error && <p id={`${id}-hint`} className="mt-1.5 text-[13px] text-mute">{hint}</p>}
      {error && <p id={`${id}-error`} role="alert" className="mt-1.5 text-[13px] font-medium text-red-800">{error}</p>}
    </div>
  );
}

export function inputProps(id, value, onChange, error, extra = {}) {
  return {
    id, name: id, value: value ?? "", className: "field",
    onChange: (e) => onChange(id, e.target.value),
    "aria-invalid": error ? "true" : "false",
    "aria-describedby": error ? `${id}-error` : undefined,
    "data-testid": `field-${id}`,
    ...extra,
  };
}

export function Honeypot({ value, onChange }) {
  return (
    <div aria-hidden="true" className="absolute -left-[9999px] h-px w-px overflow-hidden">
      <label htmlFor="hp">Ne pas remplir</label>
      <input id="hp" name="hp" tabIndex={-1} autoComplete="off" value={value} onChange={(e) => onChange("hp", e.target.value)} />
    </div>
  );
}

export function Consent({ checked, onChange, error }) {
  return (
    <div>
      <label className="flex cursor-pointer items-start gap-3 text-[14px] leading-relaxed text-mute">
        <input
          type="checkbox" checked={checked} onChange={(e) => onChange("consent", e.target.checked)} data-testid="field-consent"
          aria-invalid={error ? "true" : "false"} aria-describedby={error ? "consent-error" : undefined}
          className="mt-1 h-5 w-5 shrink-0 accent-[#2B3BD6]"
        />
        <span>
          J'accepte que les informations saisies soient utilisées par SANAA DESIGN STUDIO pour répondre à ma demande.
          Elles ne sont ni revendues ni utilisées à d'autres fins. Voir la <a href="/politique-de-confidentialite" className="underline">politique de confidentialité</a>.
        </span>
      </label>
      {error && <p id="consent-error" role="alert" className="mt-1.5 text-[13px] font-medium text-red-800">{error}</p>}
    </div>
  );
}

export const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v || "");
export const isPhone = (v) => !v || /^[0-9+().\s-]{6,40}$/.test(v);
